function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { StyledList } from './elements';
import { ListContext } from './ListContext';
import { attachSubComponents } from '../../util';
import { ListItem as Item } from './ListItem';
export const List = attachSubComponents('List', ({
  children,
  itemMinWidth = '13.25rem',
  maxItemsPerRow,
  inset,
  alignment = 'center',
  ...props
}) => /*#__PURE__*/React.createElement(StyledList, _extends({
  $maxItemsPerRow: maxItemsPerRow,
  $itemMinWidth: itemMinWidth,
  as: "ul"
}, props, {
  "data-aui": "list"
}), /*#__PURE__*/React.createElement(ListContext.Provider, {
  value: {
    inset: inset || 'var(--aui-spacing-200)',
    alignment
  }
}, children)), {
  Item
});